<div id="safety-app-device-health" ng-controller="DeviceHealthCtrl"></div>